export const AgentCardFilterKey = {
  Mentions: 'mentions',
  DepartmentCode: 'address.departmentCode',
} as const;

export type AgentCardFilterKey = (typeof AgentCardFilterKey)[keyof typeof AgentCardFilterKey];

export const AGENT_CARD_FILTER_KEYS = [
  AgentCardFilterKey.Mentions,
  AgentCardFilterKey.DepartmentCode,
] as const;
